export const SET_SELECTED_CONNECTION_FILTERS = "SET_SELECTED_CONNECTION_FILTERS";